// Контроль перехода по видам и активность кнопок
export function controlButtons (e)
{
    if (e.target.classList.contains('b_prev')) btnClickPrev(this);
    if (e.target.classList.contains('b_next')) btnClickNext(this);

    // клик по активной кнопки "Назад"
    function btnClickPrev (proxy)
    {
        if (proxy.bPrev.classList.contains('in')) {
            proxy.data.filesFlag = false;
            proxy.data.step = proxy.data.step - 1;
            proxy.data.setStepLocalStorage(proxy.visual.STEP_ID, proxy.data.step);
            proxy.data.btnNext = false;
            proxy.bPrev.classList.add('in');
            proxy.stepAjaxResult();
        }
    }

    // клик по активной кнопки "Далее"
    function btnClickNext (proxy)
    {
        const inputs = proxy.fvcContainerId.querySelectorAll('.input_control_js');

        switch (proxy.data.step) {
            case 1: // Вид визы
                if (inputs) {
                    proxy.data.inputCleaningErrorSuccess(proxy.fvcContainerId);
                    // inputControlClickBtn(inputs, proxy);
                    // radioControlWrapperTooClickBtn(proxy, 'radio_custom_dws');
                }
                break;
            case 2: // Персональные данные
                proxy.data.inputCleaningErrorSuccess(proxy.fvcContainerId);
                proxy.data.radioCleaningErrorSuccess(proxy.fvcContainerId);
                inputControlClickBtn(inputs, proxy);
                radioControlWrapperTooClickBtn(proxy);
                proxy.page.personalInformation(proxy);
                break;
            case 3: // Загрузка паспорта
                proxy.page.loadingFile(proxy);
                break;
            case 4: // Загрузка фото
                proxy.page.loadingFile(proxy)
                break;
            /*case 5: // Контактная информация
                proxy.data.btnNext = false;
                proxy.data.inputCleaningErrorSuccess(proxy.fvcContainerId);
                inputControlClickBtn(inputs, proxy);
                proxy.page.contactInformation(proxy)
                break;*/
            case 5: // Предыдущие визы
                // customSelectActive(proxy);
                proxy.data.inputCleaningErrorSuccess(proxy.fvcContainerId);
                proxy.data.radioCleaningErrorSuccess(proxy.fvcContainerId);
                radioControlWrapperTooClickBtn(proxy);
                radiosControlsClickBtn(proxy)
                inputControlClickBtn(inputs, proxy);
                radioInputControlClickBtn(proxy)
                proxy.page.previousVisas(proxy);
                break;
            case 6: // Планы по поездке
                proxy.data.inputCleaningErrorSuccess(proxy.fvcContainerId);
                inputControlClickBtn(inputs, proxy);
                proxy.page.travelPlans(proxy)
                proxy.data.btnNext = false;
                break;
            case 7: // Страховка
                // customSelectActive(proxy);
                customBoxActive(proxy);
                proxy.page.insurance(proxy);
                break;
            case 8: // Специальные предложения
                proxy.data.btnNext = false;
                proxy.page.specialOffers(proxy)
                break;
            case 9: // Оплата
                // inputControlClickBtn(inputs, proxy);
                proxy.page.payment(proxy)
                break;
        }
        // console.log('bNext => ', proxy.data.dataForm['step'+proxy.data.step])

        // const selectContainers = document.querySelectorAll('.select_container');
        // selectWrapper.removeEventListener('click', eventClickSelect);

        if (proxy.bNext.classList.contains('in')) {
            // proxy.data.btnNext ||
            // Записываем данные в LocalStorage для первого вида
            // if (proxy.data.step === 8) {
            //     proxy.data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, proxy.data.dataForm['step'+proxy.data.step], proxy.data.step);
            // }


            proxy.data.step = proxy.data.step + 1;
            proxy.data.setStepLocalStorage(proxy.visual.STEP_ID, proxy.data.step);
            proxy.bPrev.classList.add('in');

            proxy.stepAjaxResult();
        }
    }
}

// Загрузочный метод при появлении страницы
export function loadControlPage (proxy)
{
    // console.log('4444443');
}

// Метод при загрузке Ajax
export function loadControlAjax (proxy)
{
    btnControlIn (proxy);

    // На кнопках "Далее", "Назад" контролируем класс "in"
    function btnControlIn (proxy) {
        proxy.bNext.classList.remove('in');

        // Добавляем класс In если не на главной "Назад"
        if (proxy.data.step > 1) {
            proxy.bPrev.classList.add('in');
        } else if (proxy.data.step === 1) {
            // Удаляем класс In если не на главной "Назад"
            proxy.bNext.classList.remove('in');
            proxy.bPrev.classList.remove('in');
        }
    }
}

// Клик по боковому меню с переходом на определённый step
export function setNavStepActive (proxy)
{
    const frStep = proxy.navStepId.querySelectorAll('.fr_step_wrapper')
    frStep.forEach(stepDiv => {
        stepDiv.addEventListener('click', clickNavStep)
    })

    function clickNavStep(e) {
        const frStepWrapper = e.target.closest('.fr_step_wrapper')
        if (frStepWrapper.classList.contains('off')) {
            proxy.data.setStepLocalStorage(proxy.visual.STEP_ID, frStepWrapper.dataset.step)
            setTimeout(function(){
                location.reload();
            }, 100);
        }
    }
}

// Проверка на заполнение полей в Input "input_control_js"
export function inputControlClickBtn (inputs, proxy)
{
    const messageHtml = proxy.data.messageHtml;

    inputs.forEach((input) =>
    {
        const inputContainer = input.closest('.input_container');
        const required = input.hasAttribute('required');
        const en = input.classList.contains('en_js');
        const rus = input.classList.contains('ru_js');
        const value = input.value.trim();
        const length = value.length;
        const exception = input.dataset.exception;
        const regexPattern = /[0-9]/g;
        const yearPattern = /\s[12]/g;
        // const yearPattern = /\s[12]\d{3}/g;
        const cyrillicPattern = /[^а-яё\d\-\s]/gi;
        const cyrillicPatternRus = /[^а-яё\d\-\,\.\s]/gi;
        const lettersPattern = /[^a-z\d\-\,\.\s]/gi;
        const lettersPRPattern = /[^a-z\d\-\,\.\_\/\\\s]/gi;
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/gi;
        const domainPattern = /[a-zA-Z]{3,}\.[a-zA-Z]{2,}/g;

        const checkDomain = domainPattern.test(value);
        const checkYear = yearPattern.test(value);
        const checkLetters = value.match(lettersPattern);
        const checkNumber = value.match(regexPattern);
        const checkLettersPR = value.match(lettersPRPattern);
        const checkLettersRus = value.match(cyrillicPatternRus);
        const checkEmail = value.match(emailPattern);

        let flag = true; // для полей с отдельными условиями

        // проверка на этапе "Персональные данные"
        if (proxy.data.step === 2)
        {
            // Индекс и адрес проживания
            if (input.dataset.name === 'addressRegistration' && checkLettersPR) {
                setClassError(inputContainer, messageHtml('ERROR_USE_LETTERS'), proxy);
                flag = false
            }

            // Сайт компании
            if (input.dataset.name === 'companyWebsite' && !checkDomain) {
                setClassError(inputContainer, messageHtml('ERROR_INCORRECTLY'), proxy);
                flag = false
            }

            // E-mail компании
            if (input.dataset.name === 'companyEmail' && !checkEmail) {
                setClassError(inputContainer, messageHtml('ERROR_INPUT_EMAIL'), proxy);
                flag = false
            }

            // Предыдущее место работы и года работы
           if (input.dataset.name === 'companyPreviousYearsWork' && checkLetters) {
                setClassError(inputContainer, messageHtml('ERROR_USE_LETTERS'), proxy);
                flag = false
            } else if (input.dataset.name === 'companyPreviousYearsWork' && !checkNumber) {
                setClassError(inputContainer, messageHtml('ERROR_INCORRECTLY'), proxy);
                flag = false
            }
        }

        // Отбираем обязательные поля и проверяем их
        if (flag && required && !value) {
            setClassError(inputContainer, messageHtml('ERROR_REQUIRED_FIELD'), proxy);
        } else if (flag && required && length <= 2) {
            setClassError(inputContainer, messageHtml('ERROR_LENGTH'), proxy);
        } else if (flag && required && !en && !rus && checkLetters && !exception) {
            setClassError(inputContainer, messageHtml('ERROR_USE_LETTERS'), proxy);
        } else if (flag && required && en && checkLetters && !exception) {
            setClassError(inputContainer, messageHtml('ERROR_USE_LETTERS'), proxy);
        } else if (flag && required && rus && checkLettersRus) {
            if (inputContainer.querySelector('.form_additional_text_on')) inputContainer.querySelector('.form_additional_text_on').remove()
            setClassError(inputContainer, messageHtml('ADD_TEXT_FILLED_RUSSIAN'), proxy);
        } else if (flag && value) {
            setClassSuccess(inputContainer, proxy);
        }


        function setClassError (inputContainer, errorText, proxy) {
            inputContainer.classList.add('_error');
            inputContainer.insertAdjacentHTML("beforeend", errorText);
            // proxy.data.btnNext = false;

            const checkIco = inputContainer.querySelector('.check_ico');

            // Удаляем дополнительный текст по нажатию на крестик
            checkIco.addEventListener("click", function (e) {
                const inputError = e.target.closest('.input_container')
                if (inputError.classList.contains('_error')) {
                    inputError.classList.remove('_error');
                    inputError.querySelector('.form_additional_text').remove();
                }
            })
        }

        function setClassSuccess (inputContainer, proxy) {
            inputContainer.classList.add('_success');
            // proxy.data.btnNext = true;
        }
    });
}

// Контролируем список радио кнопок по нажатию на Далее
function radiosControlsClickBtn (proxy)
{
    const radioControls = proxy.fvcContainerId.querySelectorAll('.radio_control_wrapper_js');
    const fvcContainerId = proxy.fvcContainerId;
    const messageHtml = proxy.data.messageHtml;

    const dataLS = proxy.data.getStepLocalStorage(proxy.locStorStepId, proxy.data.step);

    if (!radioControls) return;

    radioControls.forEach(radios => {
        radioControl(radios)
    })

    function radioControl (radios)
    {
        const radioToo = radios.querySelector('.radio_group_js .input_box input[type=radio]')

        if (dataLS[radioToo.dataset.name+'Id']) {
            if (radios.classList.contains('_error')) radios.classList.remove('_error');
            if (!radios.classList.contains('_success')) radios.classList.add('_success');
        } else {
            if (radios.classList.contains('_success')) radios.classList.remove('_success');
            if (!radios.classList.contains('_error')) radios.classList.add('_error');
            radios.insertAdjacentHTML("beforeend", messageHtml('ERROR_SELECTED'));
            const radioContainer = radios.querySelectorAll('.radio_container')

            radioContainer.forEach((radioC) => {
                radioC.addEventListener("click", function() {
                    proxy.data.radioCleaningErrorSuccess(fvcContainerId);
                });
            })
        }
    }
}

// Проверяем заполнения радио кнопок на 5 этапе и открываем переход на 6 этап
function radioInputControlClickBtn (proxy) {
    const data = proxy.data
    // const step = 'step'+data.step;
    // const dataStep = data.dataForm[step];
    const fvcContainerId = proxy.fvcContainerId

    // Получаем объект с LC
    const dataLS = proxy.data.getStepLocalStorage(proxy.locStorStepId, proxy.data.step);

    let controller = false;
    let countControl = true;
    let error = true;

    // if (dataStep.visitedIranBeforeId === "297") {
    //     data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, data.dataForm[step], data.step);
    // }

    if (dataLS.iranVisaBeforeId === '307' && !dataLS.typeFormerIranVisa) {
        error = false
        // data.dataForm[step].iranVisaBefore = false
        // data.dataForm[step].iranVisaBeforeId = false

        const dataName = fvcContainerId.querySelector('[data-name=typeFormerIranVisa]')
        const disabledControl = dataName.closest('.disabled_control_js')


        // if (!disabledControl.classList.contains('_error')) disabledControl.classList.add('_error')
    }

    // Список обязательных полей
    const dataArr = [
        dataLS.visitedIranBeforeId,
        dataLS.visitedCountriesId,
        dataLS.obtainingVisaId,
        dataLS.iranVisaBeforeId,
        dataLS.hotelsPlaces
    ]

    // Список чекбоксов стран
    const dataInputsObj = {
        'visitedIsrael': dataLS.visitedIsrael,
        'visitedUSA': dataLS.visitedUSA,
        'visitedUK': dataLS.visitedUK,
        'visitedCanada': dataLS.visitedCanada,
    }

    // Проверка обязательных полей
    dataArr.forEach(item => {
        controller = item;
    })

    // Вы посещали ранее Иран? (Да)
    if (dataLS.visitedIranBeforeId === '297') {
        countControl = false;
        const month = fvcContainerId.querySelector('[data-name=visitedIranBeforeMonth]').closest('.month')
        const year = fvcContainerId.querySelector('[data-name=visitedIranBeforeYear]').closest('.year')
        const monthN = Number(dataLS['visitedIranBeforeMonth'])
        const yearN = Number(dataLS['visitedIranBeforeYear'])
        let yearCheck = false;
        let monthCheck = false;

        if (yearN !== 0 && yearN > 1950 && yearN <= new Date().getFullYear()) {
            yearCheck = yearN
        }

        if (monthN !== 0 && monthN < 13) {
            monthCheck = monthN
        }

        // Если активен чекбокс и не активны месяц и год
        if (dataLS.visitedIranBeforeId && monthCheck && yearCheck) {
            countControl = true;
            if (month.classList.contains('_error')) month.classList.remove('_error')
            if (year.classList.contains('_error')) year.classList.remove('_error')
        }

        // Если активен чекбокс и не активен месяц
        if (dataLS.visitedIranBeforeId && !monthCheck && yearCheck) {
            if (!month.classList.contains('_error')) month.classList.add('_error')
        }

        // Если активен чекбокс и не активен год
        if (dataLS.visitedIranBeforeId && !yearCheck && monthCheck) {
            if (!year.classList.contains('_error')) year.classList.add('_error')
        }

        // Если активен чекбокс
        if (dataLS.visitedIranBeforeId && !yearCheck && !monthCheck) {
            if (!year.classList.contains('_error')) year.classList.add('_error')
            if (!month.classList.contains('_error')) month.classList.add('_error')
        }

        if (!dataLS.visitedIranBeforeId) {
            dataLS['visitedIranBeforeYear'] = false
            dataLS['visitedIranBeforeMonth'] = false

            data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, dataLS, data.step);
        }
    }

    // Активация стран и проверка что выбрана хоть одна
    if (dataLS.visitedCountriesId === '299') {
        countControl = false;

        Object.entries(dataInputsObj).forEach((item) => {
            const month = fvcContainerId.querySelector(`[data-name=${item[0]+'Month'}]`).closest('.month')
            const year = fvcContainerId.querySelector(`[data-name=${item[0]+'Year'}]`).closest('.year')
            const yearN = Number(dataLS[item[0]+'Year'])
            const monthN = Number(dataLS[item[0]+'Month'])
            let yearCheck = false;
            let monthCheck = false;

            if (yearN !== 0 && yearN > 1950 && yearN <= new Date().getFullYear()) {
                yearCheck = yearN
            }

            if (monthN !== 0 && monthN < 13) {
                monthCheck = monthN
            }

            // Если активен чекбокс и не активны месяц и год
            if (item[1] && monthCheck && yearCheck) {
                countControl = true;
                if (month.classList.contains('_error')) month.classList.remove('_error')
                if (year.classList.contains('_error')) year.classList.remove('_error')
            }

            // Если активен чекбокс и не активен месяц
            if (item[1] && !monthCheck && yearCheck) {
                if (!month.classList.contains('_error')) month.classList.add('_error')
            }

            // Если активен чекбокс и не активен год
            if (item[1] && !yearCheck && monthCheck) {
                if (!year.classList.contains('_error')) year.classList.add('_error')
            }

            // Если активен чекбокс
            if (item[1] && !yearCheck && !monthCheck) {
                if (!year.classList.contains('_error')) year.classList.add('_error')
                if (!month.classList.contains('_error')) month.classList.add('_error')
            }

            if (!item[1]) {
                dataLS[item[0]+'Year'] = false
                dataLS[item[0]+'Month'] = false

                data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, dataLS, data.step);
            }

        })

        if (!countControl) {
            BX('299').closest('.radio_container').classList.add('_error')
        } else {
            if (BX('299').closest('.radio_container').classList.contains('_error')) BX('299').closest('.radio_container').classList.remove('_error')
        }
    }

    // Ранее вы получали отказ в визе в Иран? (Да)
    if (dataLS.iranVisaDenialId === '305') {
        const dateRefused = document.querySelector('input[data-name=dateRefused]')
        if (!dataLS.dateRefused) {
            controller = false
            dataLS.dateRefusedRFC2822 = false
            dateRefused.style.border = '1px solid #FF0000'
        }
    }

    // Ранее вы получали отказ в визе в Иран? (если есть даты но не проставлен чекбокс)
    /*if (dataLS.dateRefusedRFC2822 && dataLS.dateRefused) {
        dataLS.iranVisaDenialId = '305'
        dataLS.iranVisaDenial = 'Да'
    }*/

    if (fvcContainerId.querySelector('._error')) {
        error = false
    }

    // console.log('controller => ', controller)
    // console.log('countControl => ', countControl)
    // console.log('error => ', error)

    if (controller && countControl && error) {
        if (!proxy.bNext.classList.contains('in')) proxy.bNext.classList.add('in');
    }

    data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, dataLS, data.step);
}


// Проверка radio на их активность в группах
function radioControlWrapperTooClickBtn (proxy, klass=false)
{
    const messageHtml = proxy.data.messageHtml;
    const fvcContainerId = proxy.fvcContainerId;
    let radioContClass = '.radio_container input';
    if (klass) {
        radioContClass = klass+' input';
    }
    const radioContainerInput = fvcContainerId.querySelectorAll(radioContClass);
    const radioWrapperToo = fvcContainerId.querySelector('.radio_wrapper_too');

    if (radioWrapperToo) {
        if (checkRadio(radioContainerInput)) {
            if (radioWrapperToo.classList.contains('_error')) radioWrapperToo.classList.remove('_error');
            if (!radioWrapperToo.classList.contains('_success')) radioWrapperToo.classList.add('_success');
        } else {
            if (radioWrapperToo.classList.contains('_success')) radioWrapperToo.classList.remove('_success');
            if (!radioWrapperToo.classList.contains('_error')) radioWrapperToo.classList.add('_error');
            radioWrapperToo.insertAdjacentHTML("beforeend", messageHtml('ERROR_SELECTED'));
            const radioContainer = radioWrapperToo.querySelectorAll('.radio_container')

            radioContainer.forEach((radioC) => {
                radioC.addEventListener("click", function() {
                    proxy.data.radioCleaningErrorSuccess(fvcContainerId);
                });
            })
        }
    }

    function checkRadio (radioContainer) {
        for (let radio of radioContainer) {
            if (radio.checked) {
                return radio.value;
            }
        }
        return false;
    }
}

// Загрузка файла
export function inputDownloadFileControl (proxy)
{
    const fvcContainerId = proxy.fvcContainerId;
    const messageHtml = proxy.data.messageHtml;
    const htmlText = proxy.data.htmlText;
    proxy.data.btnNext = 1;

    const step = 'step'+proxy.data.step;

    const fileWrapper = fvcContainerId.querySelector('.download_file_wrapper');
    const input = fileWrapper.querySelector('.input_control_js');
    const inputContainer = fileWrapper.querySelector('.cont_left .input_container');
    const formAdditionalText = fileWrapper.querySelector('.form_additional_text');
    const viewFile = fileWrapper.querySelector('.view_file');
    const deleteFile = fileWrapper.querySelector('.delete_file');
    const downloadFileBtnSpan = fileWrapper.querySelector('.download_file_btn span');
    const contRight = fileWrapper.querySelector('.cont_right');

    if (fileWrapper.classList.contains('_success')) {
        if (formAdditionalText) formAdditionalText.remove();
        downloadFileBtnSpan.innerText = BX.message('SUCCESS_FILE_DOWNLOAD');
    } else if (fileWrapper.classList.contains('_error')) {
        if (viewFile) viewFile.remove();
        if (deleteFile) deleteFile.remove();
    }

    input.addEventListener('change', function (event) {
        proxy.data.fileCleaningErrorSuccess(fvcContainerId);

        const target = event.target;
        const files = target.files[0];
        let value = target.value;
        const inputBox = target.closest('.input_box');
        const targetAdditionalText = target.closest('.input_container').querySelector('.form_additional_text');
        const inputNameFile = inputBox.querySelector('.input_name_file');

        if (files) {
            const name = files.name;
            const size = files.size;
            const type = files.type;
            let imgFlag = false;
            let lcDataFail = false;

            if (inputNameFile) {
                inputNameFile.innerText = '';
                inputNameFile.innerText = name
            }

            // проверяем расширение файла
            function checkFileExtension(name, type) {
                const typeImg = type.split('/').pop();
                const nameImg = name.split('.').pop();

                return nameImg === 'jpg' || nameImg === 'jpeg';
            }

            // Проверка на размер
            if (size > 2097152) {
                fileWrapper.classList.add('_error')
                inputContainer.insertAdjacentHTML("beforeend", messageHtml('ERROR_FILE_SIZE_EXCEEDS'));
            } else if (type !== 'image/jpeg' && type !== 'image/jpg') { // проверка на тип (type !== 'image/png' && )
                fileWrapper.classList.add('_error')
                inputContainer.insertAdjacentHTML("beforeend", messageHtml('ERROR_FILE_FORMAT_ONLY'));
            } else if (!checkFileExtension(name, type)) {
                fileWrapper.classList.add('_error')
                inputContainer.insertAdjacentHTML("beforeend", messageHtml('ERROR_FILE_FORMAT_ONLY'));
            } else {
                proxy.data.filesFlag = true;
                fileWrapper.classList.remove('_error');

                fileWrapper.classList.add('_success');
                downloadFileBtnSpan.innerText = BX.message('SUCCESS_FILE_DOWNLOAD');

                if (formAdditionalText) formAdditionalText.remove();

                inputContainer.insertAdjacentHTML("beforeend", htmlText('SUCCESS_VIEW_FILE'));
                contRight.insertAdjacentHTML("beforeend", htmlText('SUCCESS_DELETE_FILE'));

                const divViewFile = fileWrapper.querySelector('.view_file');
                const divDeleteFile = fileWrapper.querySelector('.delete_file');

                const reader = new FileReader();

                reader.onload = function(er) {
                    lcDataFail = {
                        name: files.name,
                        size: files.size,
                        type: files.type,
                        path: input.value,
                        files: er.target.result,
                    }

                    proxy.data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, lcDataFail, proxy.data.step);
                    // const dataLocalStorage = proxy.data.getStepLocalStorage(proxy.locStorStepId, proxy.data.step);
                    proxy.bNext.classList.add('in');
                }

                reader.readAsDataURL(files)

                // клик "Просмотр файла"
                divViewFile.addEventListener('click', function ()
                {
                    if (!imgFlag) {
                        inputContainer.insertAdjacentHTML("beforeend", htmlText('MODAL_DIALOG_IMG'));
                        const modalDialog = inputContainer.querySelector('.modal_dialog');
                        const modalClose = modalDialog.querySelector('.modal_close');
                        const imgPreview = modalDialog.querySelector('img');

                        reader.onload = function(er) {
                            imgPreview.src = er.target.result;
                        }

                        reader.readAsDataURL(files)

                        imgFlag = true;
                        modalClose.addEventListener('click', function (ev) {
                            ev.preventDefault();
                            modalDialog.remove();
                            imgFlag = false;
                        })

                        // Делаем размер картинки по области просмотра
                        const wHeight = window.innerHeight
                        imgPreview.style.maxHeight = wHeight - 50 + 'px'
                    }
                });

                // Клик "Удалить файл"
                divDeleteFile.addEventListener('click', function () {
                    proxy.data.fileCleaningErrorSuccess(fvcContainerId);
                    proxy.data.btnNext = 2
                    lcDataFail = {}
                    const modalDialog = inputContainer.querySelector('.modal_dialog');

                    downloadFileBtnSpan.innerText = BX.message('ERROR_UPLOAD_FILE');
                    inputNameFile.innerText = '';
                    if (modalDialog) modalDialog.remove();
                    input.value = '';
                    value = '';
                    imgFlag = false;
                    proxy.data.filesFlag = false;

                    proxy.data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, lcDataFail, proxy.data.step);
                    if (proxy.bNext.classList.contains('in')) proxy.bNext.classList.remove('in');
                })
            }
        }
    });
}

// Кастомизация select
export function customSelectActive (proxy)
{
    const selectContainers = proxy.fvcContainerId.querySelectorAll('.select_container');
    selectContainers.forEach((selectCont) => {
        const selectWrapper = selectCont.querySelector('.select_wrapper');
        selectWrapper.onclick = eventClickSelect;

        // selectWrapper.addEventListener('click', eventClickSelect)
        // selectWrapper.removeEventListener('click', eventClickSelect);
    })

    // Отображение выпадающего списка в Select
    function eventClickSelect (event) {
        const eventSelectCont = event.target.closest('.select_container');

        if (!eventSelectCont.classList.contains('active') && !eventSelectCont.classList.contains('off')) {
            eventSelectCont.classList.add('active');

            const optionWrapper = eventSelectCont.querySelector('.option_wrapper');
            const inputs = optionWrapper.querySelectorAll('input');

            inputs.forEach((input) => {
                BX.bind(input, 'click', BX.proxy(optionWrapperClick, proxy));
                // input.addEventListener('click', optionWrapperClick)
            })

        } else {
            eventSelectCont.classList.remove('active');

            const optionWrapper = eventSelectCont.querySelector('.option_wrapper');
            const inputs = optionWrapper.querySelectorAll('input');

            inputs.forEach((input) => {
                BX.bind(input, 'click', BX.proxy(optionWrapperClick, proxy));
                input.removeEventListener('click', optionWrapperClick)
            })
        }
    }

    // Обработка клика по пунктам в option и записываем его в LOCAL_STORAGE
    function optionWrapperClick(event)
    {
        const target = event.target;
        const step = 'step'+this.data.step;

        const checkboxWrapper = target.closest('.checkbox_wrapper_js');
        const selectContainer = target.closest('.select_container');
        const checkSelectGroup  = target.closest('.check_select_group');
        const selectWrapper = selectContainer.querySelector('.select_wrapper');
        const span = selectContainer.querySelector('.select_wrapper span');
        const nameData = target.dataset.name;

        // Новый функционал: стоимость получаем из настроек dwstroy.core
        let arrInsurance = '';
        let text = '';
        if (this.params.CONFIG.SETTINGS_DWSTROY_CORE === 'Y') {
            arrInsurance = this.params.RESULT.ITEMS.STEP_7;
        }

        // Получаем объект с LC
        const dataLS = this.data.getStepLocalStorage(this.locStorStepId, this.data.step);
        const dataLS2 = this.data.getStepLocalStorage(this.locStorStepId, 2);

        if (selectContainer.classList.contains('_error')) selectContainer.classList.remove('_error')
        if (selectWrapper.classList.contains('disabled')) selectWrapper.classList.remove('disabled')


        // Если переключаем месяца
        if (nameData === 'month'
            || nameData === 'visitedIranBeforeMonth'
            || nameData === 'visitedIsraelMonth'
            || nameData === 'visitedUSAMonth'
            || nameData === 'visitedUKMonth'
            || nameData === 'visitedCanadaMonth'
        ) {
            span.innerText = this.message['MONTH_'+target.value];
        } else if (nameData === 'days') {
            // Новый функционал: стоимость получаем из настроек dwstroy.core
            if (arrInsurance) {
                arrInsurance.forEach(item => {
                    if (item['ID'] === target.value) {
                        text = item['TEXT']
                    }
                })
            }
            if (text) {
                span.innerText = text;
            } else {
                span.innerText = this.message['DAYS_'+target.value];
            }

            // Обновляем данные в массиве
            dataLS.validityInsurance.prise = numberWithSpaces(insuranceCost(this, dataLS2.age, target.value)) + BX.message('R')
        } else if (nameData === 'referId') {
            span.innerText = this.message['STEP1_REFER_'+target.value];
            // Обновляем данные в массиве
            dataLS.method = this.message['STEP1_REFER_MESSAGE_'+target.value];
        }
        else {
            span.innerText = target.value;
        }

        selectContainer.classList.remove('active');

        // Если кастомный чекбокс обёрнутый в checkbox_wrapper_js
        if (checkboxWrapper && target.checked) {
            const nameData = checkboxWrapper.dataset.name;
            dataLS[nameData][target.dataset.name] = target.value;

            // Формируем событие для работы на страницах
            const myEvent = new CustomEvent("customSelectClick", {
                detail: {
                    proxy: this,
                    dataForm: dataLS[nameData],
                    checkboxWrapper: checkboxWrapper,
                    value: target.value
                }
            });
            target.dispatchEvent(myEvent);
        } else { // иначе работаем со стандартны кастомным селектом
            dataLS[nameData] = target.value;

            // Если на 5 этапе перезаписываем ключ чекбокса
            if (checkSelectGroup) {
                const csgCheckbox = checkSelectGroup.querySelector('.input_box input[type=checkbox]')
                dataLS[csgCheckbox.dataset.name] = csgCheckbox.checked
            }
        }

        this.data.setStepLocalStorage(this.visual.LOCAL_STORAGE_STEP_ID, dataLS, this.data.step);
    }
}

// Кастомный checkBox
export function customBoxActive(proxy)
{
    const checkBoxWraps = document.querySelectorAll('.checkbox_wrapper_js');
    const dataName = [];

    if (checkBoxWraps) {
        checkBoxWraps.forEach((check) => {
            const input = check.querySelector('input[type="checkbox"]');
            const selectContainer = check.querySelector('.select_container');
            const stepData = proxy.data.dataForm['step' + proxy.data.step];
            const dataLocalStorage = proxy.data.getStepLocalStorage(proxy.locStorStepId, proxy.data.step);
            let flagCheck = false;
            let newDataForm = {};

            // Устанавливаем флаг чекбокса
            /*Object.entries(stepData).forEach((entry) => {
                const [key] = entry;
                dataName.push(key)
            });*/

            dataName.push(check.dataset.name)

            dataName.forEach(item => {
                if (dataLocalStorage[item]) {
                    Object.entries(dataLocalStorage[item]).forEach((entry) => {
                        const [key, value] = entry;
                        if (key === 'check') flagCheck = value;
                    });
                } else {
                    Object.entries(stepData[item]).forEach((entry) => {
                        const [key, value] = entry;
                        if (key === 'check') flagCheck = value;
                    });
                }
            })

            input.checked = flagCheck;
            check.classList.remove('active');

            if (input.checked && !check.classList.contains('active')) {
                check.classList.add('active');
            }

            // Действия по клику на чекбокс
            input.addEventListener("click", function (e) {
                const target = e.target;
                const parentCheck = target.closest('.checkbox_wrapper_js');
                const nameDataObj = parentCheck.dataset.name;
                parentCheck.classList.remove('active');

                if (selectContainer) selectContainer.classList.add('off')

                if (target.checked) {
                    flagCheck = target.checked;
                    parentCheck.classList.add('active');
                    if (selectContainer) selectContainer.classList.remove('off')
                    setCheckLC(proxy, nameDataObj, newDataForm, target.checked, input);
                } else {
                    setCheckLC(proxy, nameDataObj, newDataForm, target.checked, input);
                }
            })

            // Записываем Check в LocalStorage
            function setCheckLC (proxy, nameDataObj, newDataForm, checked, input) {
                const data = proxy.data
                const step = 'step'+data.step;
                const dataLocalStorage = proxy.data.getStepLocalStorage(proxy.locStorStepId, proxy.data.step);

                if (dataLocalStorage[nameDataObj]) {
                    Object.entries(dataLocalStorage[nameDataObj]).forEach((entry) => {
                        const [key, value] = entry;
                        // if (key === 'check') {
                        //     newDataForm[key] = checked
                        // } else {
                        //     newDataForm[key] = value
                        // }

                        if (key === 'check') {
                            data.dataForm[step][nameDataObj][key] = checked
                        } else {
                            data.dataForm[step][nameDataObj][key] = value
                        }

                        /*switch (key) {
                            case "check":
                                data.dataForm[step][nameDataObj][key] = checked
                                break;
                            case "prise":
                                const checkboxWrapper = input.closest('.checkbox_wrapper_js');
                                const price = checkboxWrapper.querySelector('.input_box_price').innerText
                                data.dataForm[step][nameDataObj][key] = price
                                break;
                            case "price":
                                data.dataForm[step][nameDataObj][key] = value
                                break;
                            case "days":
                                data.dataForm[step][nameDataObj][key] = value
                                break;
                        }*/
                    });
                }

                // Формируем свое событие
                const myEvent = new CustomEvent("customCheckClick", {
                    cancelable: true,
                    detail: {
                        proxy: proxy,
                        dataForm: data.dataForm[step][nameDataObj],
                        name: nameDataObj
                    }
                });

                input.dispatchEvent(myEvent)

                /*if (!input.dispatchEvent(myEvent)) {
                    alert('Действие отменено обработчиком');
                    proxy.data.btnNext = true;
                } else {
                    alert('!!!!!');
                    proxy.data.btnNext = false;
                }*/

                data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, data.dataForm[step], data.step);

                // proxy.data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, {[nameDataObj]: newDataForm}, proxy.data.step);
            }
        })
    }
}

// Активация календаря и запись в localStorage
export function setActiveCalendarLocalStorage (proxy, birth=false)
{
    const data = proxy.data;
    const calendars = proxy.fvcContainerId.querySelectorAll('.calendar_js');
    const step = 'step'+data.step;

    calendars.forEach((calendar) => {
        const inputCal = calendar.querySelector('input');

        // Кастомизация значений с календаря
        inputCal.addEventListener("click", function(e) {
            BX.calendar({
                node: this,
                field: this,
                bTime: false,
                bHideTime: false,
                callback_after: function (arDay) {
                    let dataLS = proxy.data.getStepLocalStorage(proxy.locStorStepId, proxy.data.step);
                    if (!dataLS) dataLS = proxy.data.dataForm[step]

                    inputCal.value = BX.date.format("d F Y", arDay);
                    dataLS[inputCal.dataset.name+'RFC2822'] = arDay
                    dataLS[inputCal.dataset.name] = inputCal.value;

                    controlValueDate(arDay, e, dataLS);

                    /*if (age >= 1) {
                        data.dataForm[step].age = age;
                    } else {
                        inputCal.value = ''
                        console.error(proxy.errorCode = -100)
                    }*/

                    // Если на странице "Персональные данные" тогда перезаписываем массив в LS
                    if (proxy.data.step === 2) {
                        const age = calculateAge(arDay);

                        if (birth) {
                            let now = new Date();
                            if (now.getFullYear() <= arDay.getFullYear()) {
                                dataLS.age = 1;
                            } else {
                                dataLS.age = age;
                            }
                        }

                        // data.dataForm[step].age = age;
                        const dataLS8 = proxy.data.getStepLocalStorage(proxy.locStorStepId, 8);

                        if (dataLS8) {
                            let dataName = [];
                            let newDataForm = {}
                            let newDF = {}

                            // Устанавливаем флаг чекбокса
                            Object.entries(dataLS8).forEach((entry) => {
                                const [key] = entry;
                                dataName.push(key)
                            });

                            dataName.forEach(item => {

                                // Если есть данные в массиве

                                if (dataLS8[item].days && dataLS8[item].prise) {
                                    const prise = numberWithSpaces(insuranceCost(proxy, age, dataLS8[item].days)) + BX.message('R');

                                    let newLS8 = {}
                                    Object.entries(dataLS8[item]).forEach((entry) => {
                                        const [key, value] = entry;

                                        if (key === 'prise') {
                                            newLS8[key] = prise
                                        } else {
                                            newLS8[key] = value
                                        }
                                    });

                                    // Перезаписываем LS новыми данными если есть изменение в календаре
                                    data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, {[item]: newLS8}, 8);
                                }
                            })
                        }

                    }

                    data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, dataLS, data.step);
                }
            });

            // console.log(e.target.dataset.change)
            // dateNextStop
            // if (e.target) dwsChangeCalendar(e);
            // if (e.target) dwsTest(e);
        });

        // Контроль ввода даты
        function controlValueDate (arDay, e, dataLS) {
            const target = e.target;
            const change = target.dataset.change;

            const currentDate = new Date();
            const d_current =  currentDate.getTime(); // текущая дата

            const d_select =  arDay.getTime(); // выбранная дата
            const d_month =  arDay.getMonth(); // выбранный месяц

            if (change === 'dateNextStop') {
                if (d_current < d_select) {
                    // console.log('Дата выше текущей')
                    errorDateRemoveLS ()
                } else {
                    target.style.border = '1px solid #017AC3'
                }

            } else  if (change === 'datePrevStop') {
                if (d_current > d_select) {
                    // console.log('Дата ниже текущей')
                    errorDateRemoveLS ()
                } else {
                    target.style.border = '1px solid #017AC3'
                }
            }

            function errorDateRemoveLS () {
                target.value = ''
                target.style.border = '1px solid #FF0000'
                dataLS[inputCal.dataset.name+'RFC2822'] = ''
                dataLS[inputCal.dataset.name] = '';
            }
        }

        function dwsTest (e) {
            var el = $('[id ^= "calendar_popup_"]');
            var links = el.find(".bx-calendar-cell");
            var currentDate = new Date();

            for (var i =0; i < links.length; i++)
            {
                var itemDate = links[i].attributes['data-date'].value;
                var d = currentDate.valueOf();
                var g = links[i].innerHTML;
                if ((itemDate - currentDate+24*60*60*1000) >= 0 && itemDate - currentDate < 6*24*60*60*1000) {
                    $('[data-date="' + itemDate +'"]').addClass("weight700");
                }
            }
        }

        // Обработчик дат в календаре
        function dwsChangeCalendar(e) {
            // dateNextStop - не больше текущей даты
            // datePrevStop - не ниже текущей даты

            const el = $('[id ^= "calendar_popup_"]');
            const links = el.find(".bx-calendar-cell");
            const date = new Date();
            let change = false;
            let target = false;
            if (e) {
                target = e.target;
                change = target.dataset.change;
            }

            if (change && target) {
                // Записываем в инпут ID календаря
                const calendarId = document.querySelector('.bx-calendar-left-arrow').closest('.popup-window').id
                target.dataset.calendar = 'calendarId-'+calendarId.replace(/[^0-9]/g,"")
            }
            else
            {
                if (document.querySelector('.popup-window').id) {
                    const calendarId ='calendarId-'+document.querySelector('.popup-window').id.replace(/[^0-9]/g,"")
                    if (document.querySelector(`[data-calendar=${calendarId}]`)) {
                        change = document.querySelector(`[data-calendar=${calendarId}]`).dataset.change
                    }
                }
            }

            document.querySelector('.bx-calendar-left-arrow').addEventListener('click', dwsChangeCalendar)
            document.querySelector('.bx-calendar-right-arrow').addEventListener('click', dwsChangeCalendar)
            document.querySelector('.bx-calendar-top-month').addEventListener('click', dwsChangeMonth)
            document.querySelector('.bx-calendar-top-year').addEventListener('click', dwsChangeYear)

            // Выбор даты не более текущей
            if (change === 'dateNextStop')
            {
                for (let i = 0; i < links.length; i++)
                {
                    const atrDate = links[i].attributes['data-date'].value;

                    //меняем класс у элемента отображающего день, который больше по дате чем текущий день
                    if (date - atrDate < 24*60*60*1000) {
                        $('[data-date="' + atrDate +'"]').addClass("bx-calendar-date-hidden disabled");
                    }
                }
            }
            else if (change === 'datePrevStop')
            {
                for (let i = 0; i < links.length; i++)
                {
                    const atrDate = links[i].attributes['data-date'].value;

                    //меняем класс у элемента отображающего день, который больше по дате чем текущий день
                    if (date - atrDate > 24*60*60*1000) {
                        $('[data-date="' + atrDate +'"]').addClass("bx-calendar-date-hidden disabled");
                    }
                }
            }
            /*else
            {
                const numDay = links[links.length - 1].attributes['data-date'].value
                const dateN = new Date(Number(numDay))




                // console.log(dateN.getMonth())

                for (let i = 0; i < links.length; i++)
                {
                    const atrDate = links[i].attributes['data-date'].value;
                    const atrText = Number(links[i].innerText);
                    $('[data-date="' + atrDate +'"]').removeClass("disabled");

                    const dateInMs = Number(atrDate)
                    const dateNew = new Date(dateInMs)

                    if (i === 0) {
                        const prevDay = new Date(Number(links[i].attributes['data-date'].value)) // прошлый
                        console.log('prevDay => ', prevDay.getMonth())
                    }

                    if (atrText === 1) {
                        const nextDay = new Date(Number(links[i].attributes['data-date'].value)) // первое число текущего месяца
                        //const sTDate = links[i].attributes['data-date'].value // первое число текущего месяца
                        //const monthT = setTDate.getMonth() // текущий месяц

                        console.log(nextDay.getMonth())
                    }

                    // date.getMonth()

                    // if (dateNew.getMonth()) {
                    //     $('[data-date="' + atrDate +'"]').removeClass("bx-calendar-date-hidden");
                    // }
                }
            }*/
        }

        // При переключении списка месяцев в календаре
        function dwsChangeMonth() {
            const el = $('[id ^= "calendar_popup_month_"]');
            const links = el.find(".bx-calendar-month");

            for (let i = 0; i < links.length; i++) {
                links[i].addEventListener('click', function (e){
                    if (e.target) {
                        setTimeout(dwsChangeCalendar,150);
                    }
                })
            }
        }

        // переключение годов и ввод года в инпуте
        function dwsChangeYear() {
            const el = $('[id ^= "calendar_popup_year_"]');
            const linksNumber = el.find(".bx-calendar-year-number");
            const linkInput = el.find(".bx-calendar-year-input");

            for (let i = 0; i < linksNumber.length; i++) {
                linksNumber[i].addEventListener('click', function (e){
                    if (e.target) {
                        setTimeout(dwsChangeCalendar,150);
                    }
                })
            }

            for (let i = 0; i < linkInput.length; i++) {
                linkInput[i].addEventListener('input', function (e){
                    if (e.target.value.length === 4) {
                        setTimeout(dwsChangeCalendar,150);
                    }
                })
            }
        }

    })
}

// Поп уведомление "Ваша заявка отправлена"
export function modalDialogSuccess(proxy, url, locHref = false)
{
    let html = 'MODAL_DIALOG_MESSAGE_SENT';
    let location = proxy.urlModalFormAnd;

    if (url) {
        html = 'MODAL_DIALOG_MESSAGE_SENT_PAY';
        location = url;
    }

    const htmlModal = proxy.data.htmlText(html);
    proxy.fvcContainerId.insertAdjacentHTML("beforeend", htmlModal);

    // Удаляем блок по нажатию на кнопку "Отлично"
    const close = proxy.fvcContainerId.querySelector('.modal_close_end')
    close.addEventListener('click', function (e) {
        const modalDialog = e.target.closest('.modal_dialog')
        modalDialog.remove();

        // Перенаправляем если установлен параметр
        if (locHref) {
            window.location.href = location;
        }


        // Обновляем страницу
        // location.reload()
    })

    if (locHref) {
        setInterval(function(){
            // Перенаправляем на визу
            window.location.href = location;

            // Обновляем страницу
            // location.reload()
        }, 4000);
    }
}

// Обновляем localStorage
export function setStepLocalStorage (key, data, step= false)
{
    // console.log('setLS => ', data)
    const dataB64 = utf8_to_b64(JSON.stringify(data))
    if (step) {
        // localStorage.setItem(key + step, JSON.stringify(data));
        localStorage.setItem(key + step, dataB64);
    } else {
        // localStorage.setItem(key, JSON.stringify(data));
        localStorage.setItem(key, dataB64);
    }
}

// Достаём с localStorage
export function getStepLocalStorage (key, step = false)
{
    let parser = '';

    if (localStorage.getItem(key + step) !== 'undefined') {
        if (step) {
            if (localStorage.getItem(key + step)) {
                // parser = JSON.parse(localStorage.getItem(key + step));
                parser = JSON.parse(b64_to_utf8(localStorage.getItem(key + step)));
            }
        } else {
            if (localStorage.getItem(key)) {
                // parser = JSON.parse(localStorage.getItem(key));
                parser = JSON.parse(b64_to_utf8(localStorage.getItem(key)));
            }
        }
    }

    return parser;
}

// Записываем в dataForm данные из LocalStorage
export function setDataFormAddLocalStorage (dataFormStep, dataLocalStorage)
{
    Object.entries(dataFormStep).forEach((entry) => {
        const [key, value] = entry;
        if (dataLocalStorage[key]) {
            dataFormStep[key] = dataLocalStorage[key]
        } else {
            dataFormStep[key] = false
        }
    });
}

// Перезаписываем LocalStorage при вводе данных в input
export function setInputClickLocalStorage (proxy, dataForm, target=false)
{
    if (target) {
        target.addEventListener('input', function (e) {
            dataForm[target.dataset.name] = e.target.value.trim()
            proxy.data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, dataForm, proxy.data.step);
        })
    } else {
        const inputs = proxy.fvcContainerId.querySelectorAll('.input_control_js');

        inputs.forEach(input => {
            input.addEventListener('input', function (e) {
                if (input.dataset.subName) {
                    dataForm[input.dataset.subName] = {
                        ...dataForm[input.dataset.subName],
                        [input.dataset.name] : e.target.value.trim()
                    }
                } else {
                    dataForm[input.dataset.name] = e.target.value.trim()
                }

                proxy.data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, dataForm, proxy.data.step);
            })
        })
    }

}

// Заполняем в input данными с dataForm и обновляем dataForm
export function setTextInputDataForm (fvcContainerId, data)
{
    const inputs = fvcContainerId.querySelectorAll('.input_control_js');

    let datasetName = [];
    let i = 0;

    // Проходимся в цикле по input
    inputs.forEach(input => {
        const value = input.value.trim();
        // Получаем ключи для записи в value
        if (input.dataset.name) datasetName.push(input.dataset.name)

        // Заполняем поля input и обновляем dataForm
        switch (input.dataset.name) {
            case datasetName[i]:
                if (!value && data[datasetName[i]]) {
                    input.value = data[datasetName[i]];
                } else if (value) {
                    data[datasetName[i]] = value;
                }
                break;
        }
        i++;
    })
}

// Проверяем input на _error
export function errorInputController (proxy, controller)
{
    const inputs = proxy.fvcContainerId.querySelectorAll('.input_control_js');
    let resultValue = [];

    inputs.forEach(input => {
        const error = input.closest('.input_container._error');
        const success = input.closest('.input_container._success');
        const required = input.hasAttribute('required');

        if (required && error) {
            resultValue.push(false)
        } else if (required && !error && !success) {
            resultValue.push(false)
        } else {
            resultValue.push(true)
        }
    })

    const result = resultValue.findIndex((item) => item === false);
    controller.input = result < 0;
}

// Перезаписываем LocalStorage при выборе с Radio
export function setRadioClickLocalStorage (proxy)
{
    const radios = proxy.fvcContainerId.querySelectorAll('.radio_control_js');
    const step = 'step'+proxy.data.step;

    // Получаем объект с LC
    let dataLS = proxy.data.getStepLocalStorage(proxy.locStorStepId, proxy.data.step);

    radios.forEach(radio => {
        radio.addEventListener('click', function (e) {

            if (!dataLS) dataLS = proxy.data.dataForm[step];

            dataLS[e.target.dataset.name] = e.target.value;
            dataLS[radio.dataset.name + 'Id'] = e.target.id;
            proxy.data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, dataLS, proxy.data.step);
        })
    })
}

// Записываем в radio данные с dataForm
export function setTextRadioDataForm (proxy, step)
{
    const radios = proxy.fvcContainerId.querySelectorAll('.radio_control_js');
    let datasetNameId = '';

    // Проходимся в цикле по radio
    radios.forEach(radio => {
        if (radio.dataset.name + 'Id') {
            datasetNameId = radio.dataset.name + 'Id'
            if (radio.id === proxy.data.dataForm[step][datasetNameId]) radio.checked = true
        }
    })
}

// Склонение
export function getNumWord(value, words)
{
    value = Math.abs(value) % 100;
    let num = value % 10;
    if(value > 10 && value < 20) return words[2];
    if(num > 1 && num < 5) return words[1];
    if(num === 1) return words[0];
    return words[2];
}

// Вычисляем количество лет
export function calculateAge(birthday)
{
    const birthdayDate = new Date(birthday);
    const currentDate = new Date();

    let age = currentDate.getFullYear() - birthdayDate.getFullYear();

    if (currentDate.getMonth() < birthdayDate.getMonth() ||
        (currentDate.getMonth() === birthdayDate.getMonth() && currentDate.getDate() < birthdayDate.getDate())) {
        age--;
    }
    return age;
}

// формируем цену в страховках
export function insuranceCost (proxy, age, days)
{
    /*
    возраст от 0 до 60 лет
    7 дней - 800
    15 дней - 1200
    1 месяц - 1600

    возраст от 61 до 70 лет
    7 дней - 800
    15 дней - 1500
    1 месяц - 1800

    возраст от 71 до 80 лет
    7 дней - 1000
    15 дней - 1800
    1 месяц - 2000

    возраст от 81 +
    7 дней - 1600
    15 дней - 3500
    1 месяц - 4100
    */

    let price = 0;

    if (age) {
        // console.log('age => ', age)
        // console.log('value => ', value)
        // console.log('value => ', days)

        // Новый функционал: стоимость получаем из настроек dwstroy.core
        if (proxy.params.CONFIG.SETTINGS_DWSTROY_CORE === 'Y') {
            proxy.params.RESULT.ITEMS.STEP_7.forEach(item => {
                if (item['ID'] === days) {
                    price = item['PRICE']
                }
            })
        } else { // прежний функционал
            switch (days) {
                case "1": //90 дней
                    if (age <= 60) price = 1150;
                    if (age >= 61 && age <= 70) price = 1150;
                    if (age >= 71 && age <= 80) price = 1150;
                    if (age >= 81) price = 1150;
                    break;
                case "2": //182 дня
                    if (age <= 60) price = 1320;
                    if (age >= 61 && age <= 70) price = 1320;
                    if (age >= 71 && age <= 80) price = 1320;
                    if (age >= 81) price = 1320;
                    break;
                case "3": //365 дней
                    if (age <= 60) price = 1650;
                    if (age >= 61 && age <= 70) price = 1650;
                    if (age >= 71 && age <= 80) price = 1650;
                    if (age >= 81) price = 1650;
                    break;
            }
        }


        /*switch (days) {
            case "1": //7 дней
                if (age <= 60) price = 800;
                if (age >= 61 && age <= 70) price = 800;
                if (age >= 71 && age <= 80) price = 1000;
                if (age >= 81) price = 1600;
                break;
            case "2": //15 дней
                if (age <= 60) price = 1200;
                if (age >= 61 && age <= 70) price = 1500;
                if (age >= 71 && age <= 80) price = 1800;
                if (age >= 81) price = 3500;
                break;
            case "3": //31 день
                if (age <= 60) price = 1600;
                if (age >= 61 && age <= 70) price = 1800;
                if (age >= 71 && age <= 80) price = 2000;
                if (age >= 81) price = 4100;
                break;
        }*/

        // console.log('price => ', price)
    }

    return price;
}

// Разделение на разряды
export function numberWithSpaces(x)
{
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

// Достаем со строки только цифры и приводим в число
export function getNumberParser (a)
{
    return parseInt(a.match(/\d/g).join(''))
}

// Ограничение ввода только цифр
export function validateNum(evt)
{
    evt.value = evt.value.replace(/[^0-9]/g,"");
}

// Очищаем от ошибок
export function deleteSuccessErrorText (container)
{
    if (container.classList.contains('_success')) {
        container.classList.remove('_success')
    } else if (container.classList.contains('_error')) {
        container.classList.remove('_error')
        if (container.querySelector('.form_additional_text')) {
            container.querySelector('.form_additional_text').remove()
        }
    }
}

// Возвращаем от "dws__step_6-477" его ID 477
export function getInputId (proxy, id) {
    const str = proxy.stepId + '_' + proxy.data.step + '-'
    return  id.replace(str, '');
}

// Возвращаем по ID 477 полное его значение "dws__step_6-477"
export function getInputStepId (proxy, id) {
    return proxy.stepId + '_' + proxy.data.step + '-' + id
}

// Кодирование в Б24
function utf8_to_b64(str) {
    return window.btoa(unescape(encodeURIComponent(str)));
}

// Декодирование Б24
function b64_to_utf8(str) {
    return decodeURIComponent(escape(window.atob(str)));
}

// true мобила  / false десктоп
export function getMobileDevise ()
{
    let modalDevise = false;

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        modalDevise = true
    }

    return modalDevise;
}

// Удаляем данные с LS (?dwsDelLS=Y&clear_cache=Y)
export function delLocalStorageGetParam (proxy, getParam, step)
{
    const localStorageId = proxy.visual.LOCAL_STORAGE_STEP_ID
    const url_string = document.URL;
    const url = new URL(url_string);
    const param = url.searchParams.get(getParam);

    // Удаляем данные с LC
    if (param === 'Y') {
        // Устанавливаем step 1
        proxy.data.setStepLocalStorage(proxy.stepId, step);

        localStorage.removeItem(proxy.stepId);
        localStorage.removeItem(localStorageId + 'result');
        for (let i = 1; i < 10; i++) {
            localStorage.removeItem(localStorageId + i);
        }

        // перезагружаем страницу по новому URL
        document.location.replace(removeURLParameter(url_string, getParam));
    }

    /*ФУНКЦИЯ ДЛЯ УДАЛЕНИЯ ОПРЕДЕЛЁННЫХ GET ПАРАМЕТРОВ */
    function removeURLParameter(url, parameter) {
        //prefer to use l.search if you have a location/link object
        const urlparts = url.split('?');
        if (urlparts.length>=2) {

            const prefix= encodeURIComponent(parameter)+'=';
            const pars= urlparts[1].split(/[&;]/g);

            //reverse iteration as may be destructive
            for (let i= pars.length; i-- > 0;) {
                //idiom for string.startsWith
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(i, 1);
                }
            }

            if(pars.length > 0) {
                url= urlparts[0]+'?'+pars.join('&');
            } else {
                url= urlparts[0];
            }

            return url;
        } else {
            return url;
        }
    }
}

// Удаляем данные с LS
export function delLocalStorage (proxy, stepId=false) {
    const localStorageId = proxy.visual.LOCAL_STORAGE_STEP_ID

    if (stepId) {
        // Устанавливаем step 1
        proxy.data.setStepLocalStorage(proxy.stepId, stepId);
    }

    // Удаляем данные с LC
    localStorage.removeItem(proxy.stepId);
    localStorage.removeItem(localStorageId + 'result');
    for (let i = 1; i < 10; i++) {
        localStorage.removeItem(localStorageId + i);
    }
}

// Получаем гет параметр со строки
export function getParams(name)
{
    if(name=(new RegExp('[?&]'+encodeURIComponent(name)+'=([^&]*)')).exec(location.search))
        return decodeURIComponent(name[1]);
}

// Устанавливаем Cookie сброса формы
export function setCookieTimeReset(proxy)
{
    const now = new Date();
    const milliseconds = now.getTime();
    BX.setCookie(proxy.visual.COOKIE_ID, milliseconds, {
        // 604800 (1-неделя)
        // 86400 (1-день)
        expires: 604800,
        path: '/services/form-visa-application/',
        secure: true
    });
}

// Сбрасываем форму и перенаправляем на основную страницу
export function timeResetLS(proxy)
{
    delLocalStorage(proxy, 1); // Сбрасываем данные с LC

    // Делаем проверку, если переход был с посадочной то пропускаем
    if (!getParams('radio')) {
        // перезагружаем страницу по новому URL
        location.replace('/services/viza-v-iran/')
    }

    /*
    const cookieDate = Number(BX.getCookie(proxy.visual.COOKIE_ID))
    if (cookieDate) {
        const date = new Date(cookieDate);
        console.log("Milliseconds = "+ date.toString());
    }*/

}